import { VideoFormatType } from '@anm/api/modules/video';
import Image from '@anm/components/image/Image';
import noop from '@anm/helpers/noop';
import { useCallback, FC } from 'react';

import { VideoRatioProps } from '../types';

import VideoRatioItem, { RatioContentWrapper } from './Wrapper';

const iconNamesMask = {
  '1:1': 'square',
  '2:3': 'vertical',
  '3:4': 'standard',
  '4:3': 'standard',
  '4:5': 'vertical_lo',
  '9:16': 'stories',
  '16:9': 'landscape',
  '1684:624': 'horizontal'
};

type VideoDisplayNameType = 'Cover';

export const displayNameMask = {
  Cover: 'Facebook Cover'
};

const RatioItem: FC<VideoRatioProps> = ({
  item,
  variant,
  direction,
  activeRatioName,
  activeRatioItemColor,
  onChange = noop
}) => {
  const { name, displayName, format } = item;

  const correctedFormat = format.replace(/0/g, '') as VideoFormatType;
  const iconName = iconNamesMask[correctedFormat] || iconNamesMask['1:1'];
  const iconUrl = `images/video-ratio-${iconName}-icon_v2.svg`;
  const isActive = activeRatioName === name;

  const displayNameWrapped = displayNameMask[displayName as VideoDisplayNameType] || displayName;
  const handleRatioChange = useCallback(() => onChange(item), [item]);

  return (
    <VideoRatioItem onClick={handleRatioChange} {...{ variant, isActive, direction, activeRatioItemColor }}>
      <RatioContentWrapper>
        <Image src={iconUrl} alt={item.name} />
        <span>{displayNameWrapped}</span>
      </RatioContentWrapper>
    </VideoRatioItem>
  );
};

export default RatioItem;
